import { CHART_BLUE, OUTLINE_RADIUS, POINT_RADIUS } from './chart-constants'
import { drawCurve, drawLine, type DataPoint, type TooltipData } from './chart-utils'

interface LineChartProps {
    data: Record<string | number, DataPoint>
    onHover: (show: boolean, tooltip: TooltipData | Record<string, never>) => void
    type: 'curve' | 'line'
}

export function LineChart({ data, onHover, type }: LineChartProps) {
    const drawFn = type === 'curve' ? drawCurve : drawLine
    const points = Object.values(data)

    const d = points.reduce((str, point, index, arr) => {
        const { xCoord: x, yCoord: y } = point
        return index === 0 ? `M ${x},${y}` : `${str} ${drawFn(point, index, arr)}`
    }, '')

    return (
        <>
            <path d={d} fill="none" stroke={CHART_BLUE} strokeWidth={2} opacity={0.5} />
            {points.map((point) => {
                const { xVal, xCoord: x, yCoord: y, yVal } = point
                const tooltip: TooltipData = { xPos: x, xVal, yPos: y, yVal }

                return (
                    <g
                        key={`${x}-${y}`}
                        style={{ cursor: 'pointer' }}
                        className="chart-point-group"
                        onMouseOver={() => onHover(true, tooltip)}
                        onMouseOut={() => onHover(false, {})}
                        onTouchStart={() => onHover(true, tooltip)}
                        onTouchEnd={() => onHover(false, {})}
                    >
                        <circle
                            cx={x}
                            cy={y}
                            r={OUTLINE_RADIUS}
                            fill="transparent"
                            stroke="transparent"
                        />
                        <circle
                            cx={x}
                            cy={y}
                            r={POINT_RADIUS}
                            fill="transparent"
                            stroke="transparent"
                        />
                    </g>
                )
            })}
            <style>{`
                .chart-point-group:hover circle:first-child {
                    stroke: ${CHART_BLUE};
                    stroke-width: 10px;
                    opacity: 0.15;
                }
                .chart-point-group:hover circle:last-child {
                    display: inline;
                    fill: white;
                    stroke: ${CHART_BLUE};
                    stroke-width: 2px;
                }
            `}</style>
        </>
    )
}
